<nav [attr.aria-label]="'SERVICE_PLAN.STEP_RAIL.NAV_LABEL' | translate">
  <ol class="step-rail">
    <li *ngFor="let step of steps; let i = index" class="step-rail-item">
      <button
        type="button"
        class="step-rail-button"
        [class.step-rail-button-current]="isCurrent(step)"
        [class.step-rail-button-completed]="isCompleted(i)"
        [disabled]="!isReachable(i)"
        [attr.aria-current]="isCurrent(step) ? 'step' : null"
        (click)="select(step, i)"
      >
        <span class="step-rail-badge" aria-hidden="true">
          <span
            *ngIf="isCompleted(i); else numberBadge"
            class="material-symbols-outlined"
            >check_circle</span
          >
          <ng-template #numberBadge>{{ i + 1 }}</ng-template>
        </span>
        <span class="step-rail-label">{{ step.titleKey | translate }}</span>
      </button>
    </li>
  </ol>
</nav>
